import { createAllRangeDates, mapCurrentDataToTimestampsTotalMembers, } from '@fourthwall/module-analytics';
export const createChartStatsTableMembersChange = (current, params) => {
    if (!current)
        return [];
    const allRangeDates = createAllRangeDates(params).reverse();
    const change = mapCurrentDataToTimestampsTotalMembers('value', current.membersChange?.data);
    return allRangeDates.map((date) => ({
        id: date,
        day: date,
        change: change[date] || 0,
    }));
};
